import React from 'react';

export function VisitorManagementSchedulingTab(): JSX.Element {
  return (
    <div>
      <div>Scheduling</div>
    </div>
  );
}
